var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("中医智能体质监测仪报告")]),_c('img',{attrs:{"src":"/common/fengmian.png","alt":""}})])}]

export { render, staticRenderFns }